import styled from 'styled-components'

import { OrderedList as DefaultOrderedList } from '../OrderedList'

export const OrderedList = styled(DefaultOrderedList)`
	margin-bottom: 16px;
`
